/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useEffect, } from 'react'
import { connect } from 'react-redux'

// Store
import { actions } from 'core/store'

// Hooks
import { useLocalStorage } from 'core/hooks/storage'
import { useGetAddressChains } from 'core/hooks/api'

import {
  Alerts,
  AppSidebarDrawer,
  RemoveUserModal,
  DeleteAddressModal,
  DeleteAddressNoteModal,
  DeleteTransactionModal,
  DeleteAiDocModal,
  AddressHistoryModal,
  ReportAddressModal,
  ReportTransactionModal,
  ReportTransferModal,
  InfoModal,
  ApproveVaspModal,
  RejectVaspModal,
  UpdateTransferModal,
  TransactionDetailsModal,
  ExploreAccountModal,
  UpgradeModal,
  RequestVaspModal,
  AddressSearchModal,
  AiDocumentUploadModal,
  // Drawers
  IndividualAccountDrawer,
  EntityAccountDrawer,
  VaspDrawer,
  TransferDrawer,
  LinkAccountDrawer,
  LinkAccountTransactionDrawer,
  UserDrawer,
} from 'views/layouts'

// Map Redux Props
const mapStateToProps = (state) => state
const mapDispatchToProps = actions
function Global(props) {
  // Destructure
  const { actions, address, } = props
  const { setAddressChains, setDefaultAddressProvider } = actions
  const { addressChains } = address

  // Hooks
  const [userCredentials] = useLocalStorage('userCredentials', {})
  const { getAddressChains, getAddressChainsData } = useGetAddressChains()

  // Functions
  function handleAddressChains() {
    if (!getAddressChainsData || Object?.keys(getAddressChainsData || {})?.length < 1) return
    // !Idk why but this is causing some bugs but we need this to optimize the process
    // if (addressChains && defaultAddressProvider) return
    const newAddressChains = {}
    const newDefaultAddressProvider = {}
    getAddressChainsData.forEach((item) => {
      // Destructure with default values
      const {
        data_type = '',
        provider_code = '',
        symbol = '',
        is_user_default = false,
        integration_id = '',
      } = item || {}

      // Initialize the data_type and provider_code if they don't exist
      if (!newAddressChains[data_type]) newAddressChains[data_type] = {}
      if (!newAddressChains[data_type][provider_code]) newAddressChains[data_type][provider_code] = {}
      // Insert the item directly
      newAddressChains[data_type][provider_code][symbol] = item
      // Handle the default address provider
      if (is_user_default && !newDefaultAddressProvider[data_type]) {
        newDefaultAddressProvider[data_type] = { provider_code, integration_id, data_type }
      }
    })

    // Sorting by symbol using .sort()
    Object.keys(newAddressChains).forEach((data_type) => {
      Object.keys(newAddressChains[data_type]).forEach((provider_code) => {
        // Get the symbols and sort them
        const symbols = Object.keys(newAddressChains[data_type][provider_code])
        const sortedSymbols = symbols.sort() // Sort the symbols
        // Create a new object to store sorted entries
        const sortedPartner = {}
        sortedSymbols.forEach((symbol) => {
          sortedPartner[symbol] = newAddressChains[data_type][provider_code][symbol]
        })
        // Replace the unsorted partner object with the sorted one
        newAddressChains[data_type][provider_code] = sortedPartner
      })
    })

    setAddressChains(newAddressChains)
    setDefaultAddressProvider(newDefaultAddressProvider)
  }

  // UseEffects
  useEffect(() => {
    if ((!addressChains || Object?.keys(addressChains || {})?.length < 1) && userCredentials.business_id) {
      getAddressChains()
    }
  }, [])
  useEffect(() => handleAddressChains(), [getAddressChainsData])
  return (
    <>
      {/* Alerts */}
      <Alerts />

      {/* Drawers */}
      <AppSidebarDrawer />
      <IndividualAccountDrawer />
      <EntityAccountDrawer />
      <VaspDrawer />
      <TransferDrawer />
      <LinkAccountDrawer />
      <LinkAccountTransactionDrawer />
      <UserDrawer />

      {/* Modals */}
      <RemoveUserModal />
      <DeleteAddressModal />
      <DeleteTransactionModal />
      <DeleteAiDocModal />
      <InfoModal />
      <DeleteAddressNoteModal />
      <AddressHistoryModal />
      <ReportAddressModal />
      <ReportTransactionModal />
      <ReportTransferModal />
      <ApproveVaspModal />
      <RejectVaspModal />
      <UpdateTransferModal />
      <TransactionDetailsModal />
      <ExploreAccountModal />
      <UpgradeModal />
      <RequestVaspModal />
      <AddressSearchModal />
      <AiDocumentUploadModal />
    </>
  )
}

Global.defaultProps = {
}

// Proptypes Validation
Global.propTypes = {
}

export default connect(mapStateToProps, mapDispatchToProps)(Global)
